import initialQuery from "./InitialProductReviewsFragment.gql";
import { REVIEWS_PAGE_LENGTH } from "./ProductReviewsConstants";

/**
 * This low-level trick allows to cope with Parameterized Fragments
 * not available in the GraphQL spec (June 2018 version).
 * See https://github.com/graphql/graphql-spec/issues/204 for further details
 *
 * For backwards compatibility, it was preferred over adding a possibly
 * error-prone default value for the variable in every GraphQL queries available.
 *
 * It makes sense to reuse the `REVIEWS_PAGE_LENGTH` variable
 * at initial fetching in a similar fashion than what's done on further
 * page navigation.
 * That's exactly what the code below does.
 */

const named = (name) => (definition) => definition?.name?.value === name;

const newQuery = initialQuery;
const sizeParameter = newQuery.definitions
  .find(named("InitialProductReviewsFragment"))
  ?.selectionSet?.selections.find(named("reviewsLayer"))
  ?.arguments?.find(named("input"))
  ?.value?.fields?.find(named("size"));

if (sizeParameter) {
  sizeParameter.value.value = REVIEWS_PAGE_LENGTH;
} else if (process.env.NODE_ENV === "development") {
  console.warn(
    "The reviewsLayer.input.size value of the `InitialProductReviewsFragment` could not be updated to match the `REVIEWS_PAGE_LENGTH` constant. Please check the `theme/modules/Reviews/ProductReviews/InitialProductReviewsFragment.gql` file to ensure your app works correctly"
  );
}

const definitions = newQuery.definitions;

// see https://github.com/apollographql/graphql-tag/blob/fbbb02e53de7e8a9a9d849ed2ee306d4d0599bfb/loader.js#L32
export { definitions };
